import React from 'react'
import { IconButton, InputAdornment, TextField } from '@mui/material'
import { Close, Search } from '@mui/icons-material'

export default function SearchField({ label, value, onChange }) {
  return <TextField size="small" label={label} value={value} onChange={e => onChange(e.target.value)} sx={{ flex: 1 }} fullWidth InputProps={{
    startAdornment: <InputAdornment position="start"><Search fontSize="small" /></InputAdornment>,
    endAdornment: value ? <InputAdornment position="end"><IconButton size="small" aria-label="Clear search" onClick={() => onChange('')}><Close fontSize="small" /></IconButton></InputAdornment> : null,
  }} />
}
